import { db } from '@/vendors/firebase/firebase';
import authService from './auth-service/authService';
import shopAuthService from './shop-auth-service/shopAuthService';
import permissionService from './permission-service/permissionService';
import userService from './user-service/userService';
import SupplierService from './supplier-service/SupplierService';
import ProductService from './product-service/ProductService';
import BDLService from './bdl-service/BDLService';

const supplierService = new SupplierService(db);
const productService = new ProductService(db);
const bdlService = new BDLService(db);

export default {
  authService,
  shopAuthService,
  permissionService,
  userService,
  supplierService,
  productService,
  bdlService,
};
